import { render } from "./Call.vue?vue&type=template&id=1fa01f5e&scoped=true&ts=true"
import script from "./Call.vue?vue&type=script&lang=ts"
export * from "./Call.vue?vue&type=script&lang=ts"

import "./Call.vue?vue&type=style&index=0&id=1fa01f5e&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa01f5e"]])

export default __exports__